<template>
    <b-modal :visible="value" @change="$emit('input', $event)" size="xl"
        :title="model._id ? 'Chi tiết Trái cây Đặc sản (Cập nhật)' : 'Thêm mới Trái cây Đặc sản'"
        title-class="modal-title-custom" no-close-on-backdrop scrollable dialogClass="modal-premium">
        <!-- Bento Grid Layout using pure Scoped CSS Grid -->
        <div class="bento-container">

            <!-- CỘT TRÁI: THÔNG TIN CHÍNH & THUỘC TÍNH CHI TIẾT (8 phần) -->
            <div class="bento-left">

                <!-- Thẻ thông tin chung -->
                <section class="bento-card">
                    <div class="card-header-custom">
                        <span class="isax isax-edit-2 icon-primary"></span>
                        <h3 class="card-title-text">Thông tin chung</h3>
                    </div>

                    <div class="row">
                        <!-- Tên trái cây -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">
                                Tên trái cây <span class="text-danger">*</span>
                            </label>
                            <input v-model="model.name" class="form-control-custom"
                                :class="{ 'border-danger-custom': submitted && $v.model.name.$error }" type="text"
                                placeholder="Ví dụ: Xoài Cát Chu Cao Lãnh" />
                            <div v-if="submitted && !$v.model.name.required" class="error-text-custom">
                                Tên trái cây không được để trống
                            </div>
                        </div>

                        <!-- Tên trái cây (EN) -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Tên trái cây (English)</label>
                            <input v-model="model.nameEn" class="form-control-custom" type="text"
                                placeholder="Example: Cao Lanh Cat Chu Mango" />
                        </div>

                        <!-- Tên khoa học -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Tên khoa học</label>
                            <input v-model="model.tenKhoaHoc" class="form-control-custom text-italic" type="text"
                                placeholder="Ví dụ: Mangifera indica L." />
                        </div>

                        <!-- Mã / Slug liên kết -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Mã / Slug liên kết <span
                                    class="text-danger">*</span></label>
                            <input v-model="model.code" class="form-control-custom"
                                :class="{ 'border-danger-custom': submitted && $v.model.code.$error }" type="text"
                                placeholder="Ví dụ: xoai-cat-chu" />
                            <div v-if="submitted && !$v.model.code.required" class="error-text-custom">
                                Mã / Slug liên kết không được để trống
                            </div>
                        </div>

                        <!-- Đặc tính sinh học -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Đặc tính sinh học</label>
                            <textarea v-model="model.dacTinhSinhHoc" class="form-control-custom" rows="5"
                                placeholder="Mô tả các đặc tính cảm quan, thớ thịt, hương thơm..."></textarea>
                        </div>

                        <!-- Đặc tính sinh học (EN) -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Đặc tính sinh học (English)</label>
                            <textarea v-model="model.dacTinhSinhHocEn" class="form-control-custom" rows="5"
                                placeholder="Describe sensory characteristics, flesh texture, aroma..."></textarea>
                        </div>

                        <!-- Diện tích & sản lượng -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Diện tích &amp; Sản lượng</label>
                            <textarea v-model="model.dienTichSanLuong" class="form-control-custom" rows="5"
                                placeholder="Ví dụ: Tổng diện tích trên 9.000 ha, sản lượng ước đạt 100.000 tấn/năm."></textarea>
                        </div>

                        <!-- Diện tích & sản lượng (EN) -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Diện tích &amp; Sản lượng (English)</label>
                            <textarea v-model="model.dienTichSanLuongEn" class="form-control-custom" rows="5"
                                placeholder="Example: Total area over 9,000 ha, estimated annual production of 100,000 tons."></textarea>
                        </div>

                        <!-- Vùng trồng tập trung -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Vùng trồng tập trung</label>
                            <textarea v-model="model.vungTrongTapTrung" class="form-control-custom" rows="5"
                                placeholder="Ví dụ: Huyện Cao Lãnh và Thành phố Cao Lãnh, Tỉnh Đồng Tháp..."></textarea>
                        </div>

                        <!-- Vùng trồng tập trung (EN) -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Vùng trồng tập trung (English)</label>
                            <textarea v-model="model.vungTrongTapTrungEn" class="form-control-custom" rows="5"
                                placeholder="Example: Cao Lanh District and Cao Lanh City, Dong Thap Province..."></textarea>
                        </div>

                        <!-- Mô tả tóm tắt nông sản -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Mô tả tóm tắt nông sản</label>
                            <textarea v-model="model.moTa" class="form-control-custom" rows="5"
                                placeholder="Mô tả ngắn gọn về giá trị OCOP, định hướng xuất khẩu của trái cây..."></textarea>
                        </div>

                        <!-- Mô tả tóm tắt nông sản (EN) -->
                        <div class="col-md-6 form-group-custom">
                            <label class="form-label-custom">Mô tả tóm tắt nông sản (English)</label>
                            <textarea v-model="model.moTaEn" class="form-control-custom" rows="5"
                                placeholder="Brief description of OCOP value, export orientation..."></textarea>
                        </div>
                    </div>
                </section>

                <!-- Thẻ thuộc tính động cấu hình chi tiết (thuocTinhs) -->
                <section class="bento-card">
                    <div class="card-header-flex border-bottom pb-3 mb-4">
                        <div class="d-flex align-items-center">
                            <span class="isax isax-setting-5 icon-primary me-2"></span>
                            <h3 class="card-title-text m-0">Thuộc tính &amp; Đặc điểm nổi bật</h3>
                        </div>
                        <button type="button" class="btn-add-group-attr" @click="addAttributeGroup">
                            <span class="isax isax-add-circle"></span> Thêm nhóm thuộc tính
                        </button>
                    </div>

                    <!-- Trạng thái trống -->
                    <div v-if="!model.thuocTinhs || model.thuocTinhs.length === 0"
                        class="text-center py-4 text-muted font-body text-sm">
                        <span class="isax isax-info-circle d-block mb-2 text-lg"></span>
                        Chưa có thuộc tính bổ sung nào được thiết lập.
                    </div>

                    <!-- Danh sách các nhóm thuộc tính -->
                    <div v-else class="attribute-groups-container">
                        <div v-for="(group, gIdx) in model.thuocTinhs" :key="'group-' + gIdx"
                            class="group-attr-card mb-4">
                            <!-- Tiêu đề nhóm -->
                            <div class="group-attr-header">
                                <div class="row align-items-center flex-grow-1">
                                    <div class="col-md-5 mb-2 mb-md-0">
                                        <input v-model="group.key" type="text" class="form-control-custom-sm font-bold"
                                            placeholder="Tên nhóm (ví dụ: Giá trị dinh dưỡng)" />
                                    </div>
                                    <div class="col-md-5 mb-2 mb-md-0">
                                        <input v-model="group.keyEn" type="text" class="form-control-custom-sm italic"
                                            placeholder="English Group Name (e.g. Nutritional Value)" />
                                    </div>
                                    <div class="col-md-2">
                                        <input v-model.number="group.index" type="number" class="form-control-custom-sm"
                                            placeholder="Thứ tự" title="Thứ tự hiển thị nhóm" />
                                    </div>
                                </div>
                                <button type="button" class="btn-delete-group" @click="removeAttributeGroup(gIdx)"
                                    title="Xóa nhóm này">
                                    <span class="isax isax-trash"></span>
                                </button>
                            </div>

                            <!-- Nội dung giá trị bên trong nhóm (Value) -->
                            <div class="group-attr-body">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="text-xs font-bold uppercase text-secondary tracking-wide">Chi tiết đặc
                                        tính thuộc nhóm</span>
                                    <button type="button" class="btn-add-item-attr"
                                        @click="addAttributeValueItem(group)">
                                        <span class="isax isax-add"></span> Thêm dòng thuộc tính
                                    </button>
                                </div>

                                <div v-if="!group.Value || group.Value.length === 0"
                                    class="text-center py-3 text-muted text-xs font-body">
                                    Nhóm chưa có thuộc tính chi tiết. Nhấn "Thêm dòng thuộc tính" để cấu hình.
                                </div>

                                <!-- Lặp danh sách dòng thuộc tính -->
                                <div v-else class="value-items-list space-y-3">
                                    <div v-for="(valItem, vIdx) in group.Value" :key="'val-' + gIdx + '-' + vIdx"
                                        class="val-item-row-card">
                                        <div class="row align-items-start g-3">
                                            <!-- Tiêu đề thuộc tính -->
                                            <div class="col-md-3">
                                                <label class="form-label-xs font-bold text-primary">Tiêu đề thuộc tính
                                                    (VI/EN)</label>
                                                <input v-model="valItem.name" type="text"
                                                    class="form-control-custom-sm mb-2"
                                                    placeholder="Ví dụ: Mùa vụ thu hoạch"
                                                    @input="syncTitleFields(valItem)" />
                                                <input v-model="valItem.nameEn" type="text"
                                                    class="form-control-custom-sm font-italic"
                                                    placeholder="Example: Harvest Season"
                                                    @input="syncTitleFields(valItem)" />
                                            </div>

                                            <!-- Giá trị thuộc tính -->
                                            <div class="col-md-7">
                                                <label class="form-label-xs font-bold text-primary">Giá trị đặc tính
                                                    (VI/EN)</label>
                                                <textarea v-model="valItem.value" class="form-control-custom-sm mb-2"
                                                    rows="3" placeholder="Ví dụ: Từ tháng 4 đến tháng 7"></textarea>
                                                <textarea v-model="valItem.valueEn"
                                                    class="form-control-custom-sm font-italic" rows="3"
                                                    placeholder="Example: From April to July"></textarea>
                                            </div>

                                            <!-- Thứ tự hiển thị -->
                                            <div class="col-md-2">
                                                <label class="form-label-xs">Thứ tự</label>
                                                <input v-model.number="valItem.index" type="number"
                                                    class="form-control-custom-sm" />
                                            </div>

                                            <!-- Thao tác xóa hàng -->
                                            <div class="col-md-1 d-flex justify-content-end align-self-center pt-3">
                                                <button type="button" class="btn-delete-row"
                                                    @click="removeAttributeValueItem(group, vIdx)"
                                                    title="Xóa dòng thuộc tính">
                                                    <span class="isax isax-close-1"></span>
                                                </button>
                                            </div>

                                            <!-- Ảnh kèm thuộc tính chi tiết (files) -->
                                            <div
                                                class="col-12 mt-2 pt-2 border-top border-dotted d-flex align-items-center gap-3">
                                                <span class="text-xs font-medium text-gray-500">Ảnh đi kèm đặc
                                                    tính:</span>

                                                <!-- Hiển thị ảnh nhỏ Thumbnail nếu có ảnh đính kèm -->
                                                <div v-for="(img, iIdx) in valItem.files" :key="'valimg-' + iIdx"
                                                    class="attr-image-preview">
                                                    <img :src="getImageUrl(img)" alt="Attr Detail Image" />
                                                    <button type="button" class="btn-delete-attr-img"
                                                        @click="removeAttrFile(valItem, iIdx)">
                                                        <span class="isax isax-close-1"></span>
                                                    </button>
                                                </div>

                                                <!-- Nút kích hoạt upload ảnh cho thuộc tính này -->
                                                <button type="button" class="btn-upload-attr-img"
                                                    @click="triggerAttrFileUpload(gIdx, vIdx)">
                                                    <span class="isax isax-camera-1 me-1"></span> Tải ảnh lên
                                                </button>
                                                <input type="file" :ref="'attrFile_' + gIdx + '_' + vIdx"
                                                    style="display: none;" accept="image/*"
                                                    @change="onAttrFileChange($event, valItem)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <!-- CỘT PHẢI: HÌNH ẢNH, BÁO CÁO & THỐNG KÊ (4 phần) -->
            <div class="bento-right">

                <!-- Thẻ hình ảnh đại diện (Avatar) -->
                <section class="bento-card">
                    <div class="card-header-flex">
                        <h3 class="card-subtitle-text">Hình ảnh đại diện</h3>
                        <button v-if="model.avatar && model.avatar.path" type="button" @click="clearAvatar"
                            class="btn-del">
                            XÓA ẢNH
                        </button>
                        <span v-else class="status-badge-success">HIỂN THỊ</span>
                    </div>

                    <!-- Image Container with Hover Camera Layer -->
                    <div class="avatar-preview-box" @click="triggerAvatarUpload">
                        <img v-if="model.avatar && (model.avatar.fileId || model.avatar.path)"
                            :src="getImageUrl(model.avatar)" alt="Mango Avatar" class="avatar-image" />
                        <div v-else class="avatar-placeholder">
                            <span class="isax isax-camera-1 placeholder-icon"></span>
                            <span class="placeholder-text">Chưa chọn ảnh</span>
                        </div>

                        <!-- Hover Overlay -->
                        <div class="avatar-hover-overlay">
                            <div class="camera-icon-wrapper">
                                <span class="isax isax-camera-1"></span>
                            </div>
                        </div>
                    </div>
                    <input type="file" ref="avatarFileInput" style="display: none;" accept="image/*"
                        @change="onAvatarFileChange" />

                    <!-- Nhập URL & tên tệp cho Avatar -->
                    <div class="avatar-inputs-group">
                        <input v-model="model.avatar.path" type="text" class="form-control-custom-sm"
                            placeholder="Đường dẫn ảnh đại diện (URL)" />
                        <input v-model="model.avatar.fileName" type="text" class="form-control-custom-sm"
                            placeholder="Tên tệp ảnh đại diện" />
                    </div>
                    <p class="avatar-dimensions-tip">Kích thước khuyên dùng: 800x800px</p>
                </section>

                <!-- Thẻ mã QR Code 2 Overlay -->
                <section class="bento-card">
                    <div class="card-header-flex">
                        <h3 class="card-subtitle-text">Mã QR Code 2 (Overlay)</h3>
                        <button v-if="model.qrCode2 && model.qrCode2.path" type="button" @click="clearQrCode2"
                            class="btn-del">
                            XÓA ẢNH
                        </button>
                        <span v-else class="status-badge-success">TÙY CHỌN</span>
                    </div>

                    <!-- Image Container with Hover Camera Layer -->
                    <div class="avatar-preview-box" @click="triggerQrCode2Upload">
                        <img v-if="model.qrCode2 && model.qrCode2.path" :src="getImageUrl(model.qrCode2)"
                            alt="QR Code 2 Overlay" class="avatar-image"
                            style="object-fit: contain; background: #fff;" />
                        <div v-else class="avatar-placeholder">
                            <span class="isax isax-camera-1 placeholder-icon"></span>
                            <span class="placeholder-text">Chưa chọn mã QR</span>
                        </div>

                        <!-- Hover Overlay -->
                        <div class="avatar-hover-overlay">
                            <div class="camera-icon-wrapper">
                                <span class="isax isax-camera-1"></span>
                            </div>
                        </div>
                    </div>
                    <input type="file" ref="qrCode2FileInput" style="display: none;" accept="image/*"
                        @change="onQrCode2FileChange" />

                    <!-- Nhập URL & tên tệp cho QR Code 2 -->
                    <div class="avatar-inputs-group">
                        <input v-model="model.qrCode2.path" type="text" class="form-control-custom-sm"
                            placeholder="Đường dẫn QR Code (URL)" />
                        <input v-model="model.qrCode2.fileName" type="text" class="form-control-custom-sm"
                            placeholder="Tên tệp QR Code" />
                    </div>
                    <p class="avatar-dimensions-tip">Kích thước khuyên dùng: 300x300px</p>
                </section>

                <!-- Thẻ bộ sưu tập ảnh (Gallery) -->
                <section class="bento-card">
                    <div class="card-header-flex mb-3">
                        <div>
                            <h3 class="card-subtitle-text">Bộ sưu tập ảnh</h3>
                            <p class="gallery-count-text" v-if="model.files && model.files.length > 0">
                                Đã tải lên {{ model.files.length }} ảnh chi tiết
                            </p>
                        </div>
                        <button type="button" @click="triggerGalleryUpload" class="add-image-btn">
                            <span class="isax isax-add-circle"></span> Thêm ảnh
                        </button>
                    </div>

                    <!-- Gallery Grid -->
                    <div class="gallery-grid-custom">
                        <div v-for="(file, index) in model.files" :key="index" class="gallery-item-wrapper">
                            <!-- Order Badge -->
                            <span class="gallery-order-badge">#{{ index + 1 }}</span>

                            <img v-if="file.fileId || file.path" :src="getImageUrl(file)"
                                :alt="file.fileName || 'Gallery Image'" class="gallery-img" />
                            <div v-else class="gallery-img-placeholder">
                                <span class="isax isax-image placeholder-icon"></span>
                                <span>Chờ URL</span>
                            </div>

                            <!-- Nút xóa ảnh -->
                            <button type="button" @click.stop="removeFileItem(index)" class="delete-gallery-btn"
                                title="Xóa ảnh này">
                                <span class="isax isax-close-1"></span>
                            </button>
                        </div>

                        <!-- Upload Box tích hợp trong Grid -->
                        <div @click="triggerGalleryUpload" class="upload-box-custom">
                            <span class="isax isax-document-upload upload-icon"></span>
                            <span class="upload-text">Tải lên</span>
                        </div>
                    </div>
                    <input type="file" ref="galleryFileInput" style="display: none;" accept="image/*" multiple
                        @change="onGalleryFileChange" />

                    <!-- Nút kích hoạt cấu hình URL chi tiết -->
                    <div class="gallery-toggle-wrapper" v-if="model.files && model.files.length > 0">
                        <button type="button" class="btn-toggle-links" @click="isShowingLinks = !isShowingLinks">
                            <span
                                :class="['isax', isShowingLinks ? 'isax-eye-slash' : 'isax-eye', 'icon-toggle']"></span>
                            {{ isShowingLinks ? 'Ẩn danh sách URL ảnh chi tiết' : 'Chỉnh sửa URL ảnh chi tiết (' +
                                model.files.length + ')' }}
                        </button>
                    </div>

                    <!-- Nhập thông tin URL chi tiết -->
                    <div v-if="isShowingLinks && model.files && model.files.length > 0" class="gallery-links-scroller">
                        <div v-for="(file, index) in model.files" :key="'edit-' + index" class="link-item-row">
                            <div class="row-thumbnail">
                                <img v-if="file.fileId || file.path" :src="getImageUrl(file)" class="thumb-img" />
                                <span v-else class="isax isax-image thumb-icon"></span>
                                <span class="thumb-index">#{{ index + 1 }}</span>
                            </div>
                            <div class="row-inputs">
                                <input v-model="file.path" type="text" class="form-control-custom-xs"
                                    placeholder="Đường dẫn ảnh (URL)..." />
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Thẻ Tài liệu & Báo cáo đính kèm (fileGhiChu - Trường mới) -->
                <section class="bento-card">
                    <div class="card-header-flex mb-3">
                        <h3 class="card-subtitle-text">Tài liệu, Báo cáo</h3>
                        <button type="button" class="add-image-btn" @click="triggerDocUpload">
                            <span class="isax isax-document-upload"></span> Thêm File
                        </button>
                    </div>

                    <input type="file" ref="docFileInput" style="display: none;" accept=".pdf,.doc,.docx,.xls,.xlsx"
                        @change="onDocFileChange" />

                    <!-- Trạng thái trống -->
                    <div v-if="!model.fileGhiChu || model.fileGhiChu.length === 0"
                        class="text-center py-3 text-muted text-xs font-body">
                        Chưa có tài liệu đính kèm (PDF, Bản đồ...)
                    </div>

                    <!-- Danh sách các file đính kèm -->
                    <div v-else class="space-y-2 max-h-[200px] overflow-y-auto pr-1">
                        <div v-for="(doc, dIdx) in model.fileGhiChu" :key="'doc-' + dIdx" class="doc-file-item-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2 overflow-hidden pr-2">
                                    <span class="isax isax-document-text text-danger text-lg flex-shrink-0"></span>
                                    <div class="overflow-hidden">
                                        <p class="doc-file-name text-truncate" :title="doc.fileName">
                                            {{ doc.fileName }}
                                        </p>
                                        <span class="doc-file-ext">{{ doc.ext }}</span>
                                    </div>
                                </div>
                                <button type="button" class="btn-delete-doc" @click="removeDocFile(dIdx)"
                                    title="Xóa tài liệu này">
                                    <span class="isax isax-close-1"></span>
                                </button>
                            </div>
                            <div class="mt-2">
                                <input v-model="doc.path" type="text" class="form-control-custom-xs"
                                    placeholder="Đường dẫn tài liệu (URL)" />
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Thẻ Infographics đính kèm (infographics - Trường mới) -->
                <section class="bento-card">
                    <div class="card-header-flex mb-3">
                        <h3 class="card-subtitle-text">Ảnh Infographics (Tối đa 2)</h3>
                    </div>

                    <div class="space-y-3">
                        <!-- Infographic Tiếng Việt (Index 0) -->
                        <div class="infographic-item-card mb-3 pt-3 pb-3 border-bottom border-dotted">
                            <div class="d-flex align-items-center justify-content-between">
                                <label class="form-label-xs font-bold text-primary m-0">Infographic Tiếng Việt</label>
                                <button
                                    v-if="model.infographics[0] && (model.infographics[0].fileId || model.infographics[0].path)"
                                    type="button" @click="clearInfographic(0)" class="btn-del">
                                    XÓA
                                </button>
                            </div>

                            <div class="avatar-preview-box infographic-preview-box"
                                @click="triggerInfographicUpload(0)">
                                <img v-if="model.infographics[0] && (model.infographics[0].fileId || model.infographics[0].path)"
                                    :src="getImageUrl(model.infographics[0])" alt="Infographic VI"
                                    class="avatar-image infographic-image" />
                                <div v-else class="avatar-placeholder py-2">
                                    <span
                                        class="isax isax-camera-1 placeholder-icon infographic-placeholder-icon"></span>
                                    <span class="placeholder-text infographic-placeholder-text">Chọn ảnh Infographic
                                        (VI)</span>
                                </div>
                                <div class="avatar-hover-overlay">
                                    <div class="camera-icon-wrapper infographic-camera-wrapper">
                                        <span class="isax isax-camera-1 infographic-camera-icon"></span>
                                    </div>
                                </div>
                            </div>
                            <input type="file" ref="infographicFileInput_0" style="display: none;" accept="image/*"
                                @change="onInfographicFileChange($event, 0)" />

                            <div class="mt-2">
                                <input v-model="model.infographics[0].path" type="text" class="form-control-custom-xs"
                                    placeholder="Đường dẫn Infographic VI (URL)" />
                            </div>
                        </div>

                        <!-- Infographic Tiếng Anh (Index 1) -->
                        <div class="infographic-item-card">
                            <div class="d-flex align-items-center justify-content-between">
                                <label class="form-label-xs font-bold text-primary m-0">Infographic English</label>
                                <button
                                    v-if="model.infographics[1] && (model.infographics[1].fileId || model.infographics[1].path)"
                                    type="button" @click="clearInfographic(1)" class="btn-del">
                                    XÓA
                                </button>
                            </div>

                            <div class="avatar-preview-box infographic-preview-box"
                                @click="triggerInfographicUpload(1)">
                                <img v-if="model.infographics[1] && (model.infographics[1].fileId || model.infographics[1].path)"
                                    :src="getImageUrl(model.infographics[1])" alt="Infographic EN"
                                    class="avatar-image infographic-image" />
                                <div v-else class="avatar-placeholder py-2">
                                    <span
                                        class="isax isax-camera-1 placeholder-icon infographic-placeholder-icon"></span>
                                    <span class="placeholder-text infographic-placeholder-text">Chọn ảnh Infographic
                                        (EN)</span>
                                </div>
                                <div class="avatar-hover-overlay">
                                    <div class="camera-icon-wrapper infographic-camera-wrapper">
                                        <span class="isax isax-camera-1 infographic-camera-icon"></span>
                                    </div>
                                </div>
                            </div>
                            <input type="file" ref="infographicFileInput_1" style="display: none;" accept="image/*"
                                @change="onInfographicFileChange($event, 1)" />

                            <div class="mt-2">
                                <input v-model="model.infographics[1].path" type="text" class="form-control-custom-xs"
                                    placeholder="Đường dẫn Infographic EN (URL)" />
                            </div>
                        </div>
                    </div>
                </section>


                <!-- Thẻ Danh sách Chứng nhận (chungNhan - Trường mới) -->
                <section class="bento-card">
                    <div class="card-header-flex border-bottom pb-3 mb-3">
                        <div class="d-flex align-items-center">
                            <span class="isax isax-verify icon-primary me-2"></span>
                            <h3 class="card-subtitle-text m-0">Danh sách Chứng nhận</h3>
                        </div>
                        <button type="button" class="btn-add-group-attr" @click="addChungNhan">
                            <span class="isax isax-add-circle"></span> Thêm mới
                        </button>
                    </div>

                    <input type="file" ref="certImageInput" style="display: none;" accept="image/*"
                        @change="onCertImageChange" />

                    <!-- Trạng thái trống -->
                    <div v-if="!model.chungNhan || model.chungNhan.length === 0"
                        class="text-center py-3 text-muted text-xs font-body">
                        Chưa có chứng nhận nào. Nhấn "Thêm mới" để bắt đầu.
                    </div>

                    <!-- Danh sách các chứng nhận -->
                    <div v-else class="certifications-list-scroller">
                        <div v-for="(cn, idx) in model.chungNhan" :key="'cn-' + idx" class="cert-item-card p-3 mb-3">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <span class="badge bg-soft-primary">Chứng nhận #{{ idx + 1 }}</span>
                                <div class="d-flex align-items-center gap-2">
                                    <b-form-checkbox v-model="cn.isBool" switch class="custom-switch-premium m-0">
                                        <span class="text-xs font-bold">Hiệu lực</span>
                                    </b-form-checkbox>
                                    <button type="button" class="btn-delete-doc p-1" @click="removeChungNhan(idx)"
                                        title="Xoá chứng nhận">
                                        <span class="isax isax-close-1"></span>
                                    </button>
                                </div>
                            </div>

                            <div class="form-group-custom mb-2">
                                <label class="form-label-xs text-primary font-bold">Tên chứng nhận (key)</label>
                                <input v-model="cn.key" type="text" class="form-control-custom-sm"
                                    placeholder="Ví dụ: VietGAP, OCOP 4★..." />
                            </div>

                            <div class="form-group-custom mb-2">
                                <label class="form-label-xs text-primary font-bold">Tên tiếng Anh (keyEn)</label>
                                <input v-model="cn.keyEn" type="text" class="form-control-custom-sm font-italic"
                                    placeholder="Example: VietGAP, OCOP 4★..." />
                            </div>

                            <!-- Upload hình ảnh chứng nhận -->
                            <div class="form-group-custom mt-2">
                                <label class="form-label-xs text-primary font-bold">Hình ảnh chứng nhận (Logo)</label>
                                <div class="d-flex align-items-center gap-3">
                                    <!-- Box Preview -->
                                    <div class="cert-image-preview-wrapper">
                                        <img v-if="cn.files && cn.files.length > 0 && (cn.files[0].fileId || cn.files[0].path)"
                                            :src="getImageUrl(cn.files[0])" class="cert-image-preview" />
                                        <div v-else class="cert-image-placeholder">
                                            <span class="isax isax-image text-muted"></span>
                                        </div>
                                    </div>

                                    <!-- Nút hành động -->
                                    <div class="d-flex flex-column gap-1">
                                        <button type="button" class="btn btn-outline-success btn-xs py-1 px-2 text-xs"
                                            @click="triggerCertImageUpload(idx)">
                                            <span class="isax isax-import me-1"></span> Chọn ảnh
                                        </button>
                                        <button v-if="cn.files && cn.files.length > 0" type="button"
                                            class="btn btn-outline-danger btn-xs py-1 px-2 text-xs"
                                            @click="deleteCertImage(idx)">
                                            <span class="isax isax-trash me-1"></span> Xoá ảnh
                                        </button>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <input :value="cn.files && cn.files[0] ? cn.files[0].path : ''"
                                        @input="updateCertUrl(idx, $event.target.value)"
                                        type="text" class="form-control-custom-xs"
                                        placeholder="Hoặc nhập URL hình ảnh" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Thẻ cấu hình & Thống kê -->
                <section class="bento-card">
                    <h3 class="card-subtitle-text mb-3">Cấu hình &amp; Thống kê</h3>

                    <div class="stats-group-wrapper">
                        <!-- Thứ tự hiển thị -->
                        <div class="form-group-custom mb-2">
                            <label class="form-label-custom mb-1">
                                Thứ tự hiển thị
                            </label>
                            <input v-model.number="model.sort" class="form-control-custom-sm" type="number" />
                        </div>

                        <!-- Chứng nhận OCOP / Đặc sản -->
                        <!-- <div class="form-group-custom mb-3 mt-2">
                            <b-form-checkbox v-model="model.isBool" switch class="custom-switch-premium">
                                <span class="form-label-custom m-0 d-inline-block"
                                    style="transform: translateY(-2px); cursor: pointer; user-select: none;">
                                    Trái cây chủ lực
                                </span>
                            </b-form-checkbox>
                        </div> -->

                        <!-- Ghi chú vận hành -->
                        <div class="form-group-custom mb-2">
                            <label class="form-label-custom mb-1 mt-3">
                                Ghi chú vận hành
                            </label>
                            <textarea v-model="model.ghiChu" class="form-control-custom-sm" rows="2"
                                placeholder="Ghi chú hệ thống, phân loại..."></textarea>
                        </div>

                        <!-- Ghi chú vận hành (EN) -->
                        <div class="form-group-custom m-0">
                            <label class="form-label-custom mb-1 mt-2">
                                Ghi chú vận hành (English)
                            </label>
                            <textarea v-model="model.ghiChuEn" class="form-control-custom-sm" rows="2"
                                placeholder="System notes, classification..."></textarea>
                        </div>

                        <!-- Lượt xem -->
                        <div class="views-counter-box">
                            <div class="views-title">
                                <span class="isax isax-eye icon-secondary me-1"></span>
                                <span class="views-label">Lượt xem sản phẩm</span>
                            </div>
                            <span class="views-value fw-bold">{{ model.view || 0 }} Lượt</span>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <!-- Custom Footer Modal -->
        <template #modal-footer>
            <b-button variant="outline-secondary" class="footer-btn-cancel" @click="$emit('input', false)">
                HỦY BỎ
            </b-button>
            <b-button variant="primary" class="footer-btn-save" @click="submitForm">
                <span class="isax isax-archive-book icon-save-modal"></span> LƯU THAY ĐỔI
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: "FruitModal",
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        fruitData: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            submitted: false,
            model: this.getEmptyFruitModel(),
            isShowingLinks: false,
            uploadingCertIndex: null,
        };
    },
    validations: {
        model: {
            name: { required },
            code: { required },
            sort: { numeric },
        },
    },
    watch: {
        value(val) {
            if (val) {
                this.submitted = false;
                this.$v.$reset();
                if (this.fruitData) {
                    const parsedData = JSON.parse(JSON.stringify(this.fruitData));

                    // Thiết lập các thuộc tính lồng nhau có tính Reactive bằng cách trộn với Model trống ban đầu
                    const empty = this.getEmptyFruitModel();

                    if (!parsedData.avatar) parsedData.avatar = empty.avatar;
                    if (!parsedData.qrCode2) parsedData.qrCode2 = empty.qrCode2;
                    if (!parsedData.files) parsedData.files = empty.files;
                    if (!parsedData.thuocTinhs) parsedData.thuocTinhs = empty.thuocTinhs;
                    if (!parsedData.fileGhiChu) parsedData.fileGhiChu = empty.fileGhiChu;
                    if (!parsedData.infographics) {
                        parsedData.infographics = empty.infographics;
                    } else if (Array.isArray(parsedData.infographics)) {
                        while (parsedData.infographics.length < 2) {
                            parsedData.infographics.push({ fileId: "", fileName: "", ext: "", path: "" });
                        }
                    }
                    if (!parsedData.chungNhan) {
                        parsedData.chungNhan = empty.chungNhan;
                    } else if (Array.isArray(parsedData.chungNhan)) {
                        parsedData.chungNhan.forEach(cn => {
                            if (!cn.files) {
                                cn.files = [];
                            }
                        });
                    }

                    // Tiến hành gán đè Object.assign để bảo toàn hoàn toàn tính Reactive cho các mảng lồng sâu trong Vue 2
                    this.model = Object.assign({}, empty, parsedData);
                } else {
                    this.model = this.getEmptyFruitModel();
                }
            }
        },
        "model.name"(newVal) {
            if (!this.model._id && newVal) {
                this.model.code = this.generateSlug(newVal);
            }
        }
    },
    methods: {
        // 🌐 THAY THẾ THAM CHIẾU MẢNG ĐỂ KHẮC PHỤC LỖI REACTIVITY
        addChungNhan() {
            if (!this.model.chungNhan) {
                this.$set(this.model, 'chungNhan', []);
            }
            const newItem = {
                key: "",
                keyEn: "",
                index: this.model.chungNhan.length,
                files: [],
                isBool: true
            };
            // Thay vì dùng push(), ta gán mảng mới để Vue 2 bắt buộc kích hoạt render
            this.model.chungNhan = [...this.model.chungNhan, newItem];
            this.model.chungNhans = this.model.chungNhan;
        },
        async removeChungNhan(index) {
            if (!this.model.chungNhan) {
                this.$set(this.model, 'chungNhan', []);
            }
            const cn = this.model.chungNhan[index];
            if (cn && cn.files && cn.files.length > 0) {
                for (const f of cn.files) {
                    if (f.fileId) {
                        try {
                            await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${f.fileId}`);
                        } catch (error) {
                            console.error("Error deleting certification file:", error);
                        }
                    }
                }
            }
            // Lọc bỏ phần tử bằng filter để cập nhật tham chiếu mảng mới
            this.model.chungNhan = this.model.chungNhan.filter((_, idx) => idx !== index);
            this.model.chungNhans = this.model.chungNhan;
        },
        triggerCertImageUpload(index) {
            this.uploadingCertIndex = index;
            this.$refs.certImageInput.click();
        },
        async onCertImageChange(event) {
            if (this.uploadingCertIndex === null) return;
            if (event.target && event.target.files.length > 0) {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("files", file);

                let loader = this.getLoader(event.target);
                try {
                    const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                    let resultData = response.data;
                    if (resultData.code == 0) {
                        const updatedFile = {
                            fileId: resultData.data.fileId,
                            fileName: resultData.data.fileName,
                            ext: resultData.data.ext,
                            path: resultData.data.path,
                        };
                        if (!this.model.chungNhan) {
                            this.$set(this.model, 'chungNhan', []);
                        }

                        // Cập nhật thuộc tính lồng trong mảng một cách an toàn
                        const updatedChungNhan = [...this.model.chungNhan];
                        updatedChungNhan[this.uploadingCertIndex].files = [updatedFile];
                        this.model.chungNhan = updatedChungNhan;
                        this.model.chungNhans = this.model.chungNhan;
                    } else {
                        this.notifyError(resultData);
                    }
                } catch (error) {
                    console.error("Error uploading cert image:", error);
                } finally {
                    if (loader) loader.hide();
                    this.uploadingCertIndex = null;
                    event.target.value = '';
                }
            }
        },
        async deleteCertImage(index) {
            if (!this.model.chungNhan) {
                this.$set(this.model, 'chungNhan', []);
            }
            const cn = this.model.chungNhan[index];
            if (cn && cn.files && cn.files.length > 0) {
                for (const f of cn.files) {
                    if (f.fileId) {
                        try {
                            await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${f.fileId}`);
                        } catch (error) {
                            console.error("Error deleting cert image:", error);
                        }
                    }
                }
            }

            const updatedChungNhan = [...this.model.chungNhan];
            updatedChungNhan[index].files = [];
            this.model.chungNhan = updatedChungNhan;
            this.model.chungNhans = this.model.chungNhan;
        },
        updateCertUrl(index, value) {
            const updatedChungNhan = [...this.model.chungNhan];
            if (!updatedChungNhan[index].files) {
                updatedChungNhan[index].files = [];
            }
            if (updatedChungNhan[index].files.length === 0) {
                updatedChungNhan[index].files.push({ fileId: "", fileName: "", ext: "", path: "" });
            }
            updatedChungNhan[index].files[0].path = value;
            this.model.chungNhan = updatedChungNhan;
            this.model.chungNhans = this.model.chungNhan;
        },
        getEmptyFruitModel() {
            return {
                _id: null,
                name: "",
                nameEn: "",
                code: "",
                sort: 1,
                tenKhoaHoc: "",
                dacTinhSinhHoc: "",
                dacTinhSinhHocEn: "",
                dienTichSanLuong: "",
                dienTichSanLuongEn: "",
                vungTrongTapTrung: "",
                vungTrongTapTrungEn: "",
                moTa: "",
                moTaEn: "",
                avatar: {
                    fileId: "",
                    fileName: "",
                    ext: "",
                    path: "",
                },
                qrCode2: {
                    fileId: "",
                    fileName: "",
                    ext: "",
                    path: "",
                },
                files: [],
                thuocTinhs: [], // Nhóm các thuộc tính chi tiết (Mới)
                fileGhiChu: [], // Danh sách tài liệu (Mới)
                infographics: [
                    { fileId: "", fileName: "", ext: "", path: "" },
                    { fileId: "", fileName: "", ext: "", path: "" }
                ],
                chungNhan: [],

                ghiChu: "",
                ghiChuEn: "",
                view: 0,
            };
        },
        // Quản lý file của mảng Gallery
        addFileItem() {
            if (!this.model.files) {
                this.$set(this.model, "files", []);
            }
            const newFile = {
                fileId: Math.random().toString(36).substring(2, 15),
                fileName: "",
                ext: ".jpg",
                path: "",
            };
            this.model.files = [...this.model.files, newFile];
        },
        async removeFileItem(index) {
            const file = this.model.files[index];
            if (file && file.fileId) {
                try {
                    await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${file.fileId}`);
                } catch (error) {
                    console.error("Error deleting gallery file:", error);
                }
            }
            this.model.files = this.model.files.filter((_, idx) => idx !== index);
        },
        // Quản lý ảnh Avatar
        async clearAvatar() {
            if (this.model.avatar && this.model.avatar.fileId) {
                try {
                    await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.model.avatar.fileId}`);
                } catch (error) {
                    console.error("Error deleting avatar file:", error);
                }
            }
            this.model.avatar = { fileId: "", fileName: "", ext: "", path: "" };
        },
        triggerAvatarUpload() {
            this.$refs.avatarFileInput.click();
        },
        async onAvatarFileChange(event) {
            if (event.target && event.target.files.length > 0) {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("files", file);

                let loader = this.getLoader(event.target);
                try {
                    const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                    let resultData = response.data;
                    if (resultData.code == 0) {
                        this.model.avatar = {
                            fileId: resultData.data.fileId,
                            fileName: resultData.data.fileName,
                            ext: resultData.data.ext,
                            path: resultData.data.path,
                        };
                    } else {
                        this.notifyError(resultData);
                    }
                } catch (error) {
                    console.error("Error uploading avatar:", error);
                } finally {
                    if (loader) loader.hide();
                }
            }
        },
        async clearQrCode2() {
            if (this.model.qrCode2 && this.model.qrCode2.fileId) {
                try {
                    await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.model.qrCode2.fileId}`);
                } catch (error) {
                    console.error("Error deleting qrCode2 file:", error);
                }
            }
            this.model.qrCode2 = { fileId: "", fileName: "", ext: "", path: "" };
        },
        triggerQrCode2Upload() {
            this.$refs.qrCode2FileInput.click();
        },
        async onQrCode2FileChange(event) {
            if (event.target && event.target.files.length > 0) {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("files", file);

                let loader = this.getLoader(event.target);
                try {
                    const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                    let resultData = response.data;
                    if (resultData.code == 0) {
                        this.model.qrCode2 = {
                            fileId: resultData.data.fileId,
                            fileName: resultData.data.fileName,
                            ext: resultData.data.ext,
                            path: resultData.data.path,
                        };
                    } else {
                        this.notifyError(resultData);
                    }
                } catch (error) {
                    console.error("Error uploading qrCode2:", error);
                } finally {
                    if (loader) loader.hide();
                }
            }
        },
        generateSlug(str) {
            if (!str) return "";
            str = str.toLowerCase();
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/[^a-z0-9 -]/g, "");
            str = str.replace(/\s+/g, "-");
            str = str.replace(/-+/g, "-");
            return str;
        },
        triggerGalleryUpload() {
            this.$refs.galleryFileInput.click();
        },
        async onGalleryFileChange(event) {
            if (event.target && event.target.files.length > 0) {
                let loader = this.getLoader(event.target);
                try {
                    const files = event.target.files;
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        const formData = new FormData();
                        formData.append("files", file);
                        const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                        let resultData = response.data;
                        if (resultData.code == 0) {
                            if (!this.model.files) {
                                this.$set(this.model, "files", []);
                            }
                            this.model.files = [
                                ...this.model.files,
                                {
                                    fileId: resultData.data.fileId,
                                    fileName: resultData.data.fileName,
                                    ext: resultData.data.ext,
                                    path: resultData.data.path,
                                }
                            ];
                        }
                    }
                } catch (error) {
                    console.error("Error uploading gallery images:", error);
                } finally {
                    if (loader) loader.hide();
                }
            }
        },

        // 📝 QUẢN LÝ THUỘC TÍNH ĐỘNG (thuocTinhs)
        addAttributeGroup() {
            if (!this.model.thuocTinhs) {
                this.$set(this.model, "thuocTinhs", []);
            }
            const newGroup = {
                key: "",
                keyEn: "",
                index: this.model.thuocTinhs.length,
                Value: []
            };
            this.model.thuocTinhs = [...this.model.thuocTinhs, newGroup];
        },
        removeAttributeGroup(index) {
            this.model.thuocTinhs = this.model.thuocTinhs.filter((_, idx) => idx !== index);
        },
        addAttributeValueItem(group) {
            if (!group.Value) {
                this.$set(group, "Value", []);
            }
            const newItem = {
                index: group.Value.length,
                name: "",
                nameEn: "",
                tieuDe: "",
                tieuDeEn: "",
                value: "",
                valueEn: "",
                files: []
            };
            group.Value = [...group.Value, newItem];
        },
        removeAttributeValueItem(group, index) {
            group.Value = group.Value.filter((_, idx) => idx !== index);
        },
        syncTitleFields(valItem) {
            valItem.tieuDe = valItem.name;
            valItem.tieuDeEn = valItem.nameEn;
        },
        triggerAttrFileUpload(groupIndex, valueIndex) {
            const refName = `attrFile_${groupIndex}_${valueIndex}`;
            if (this.$refs[refName] && this.$refs[refName][0]) {
                this.$refs[refName][0].click();
            }
        },
        async onAttrFileChange(event, valItem) {
            if (event.target && event.target.files.length > 0) {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("files", file);

                let loader = this.getLoader(event.target);
                try {
                    const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                    let resultData = response.data;
                    if (resultData.code == 0) {
                        if (!valItem.files) {
                            this.$set(valItem, "files", []);
                        }
                        valItem.files = [
                            ...valItem.files,
                            {
                                fileId: resultData.data.fileId,
                                fileName: resultData.data.fileName,
                                ext: resultData.data.ext,
                                path: resultData.data.path
                            }
                        ];
                    } else {
                        this.notifyError(resultData);
                    }
                } catch (error) {
                    console.error("Error uploading attribute image:", error);
                } finally {
                    if (loader) loader.hide();
                }
            }
        },
        async removeAttrFile(valItem, imgIndex) {
            const file = valItem.files[imgIndex];
            if (file && file.fileId) {
                try {
                    await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${file.fileId}`);
                } catch (error) {
                    console.error("Error deleting attribute file:", error);
                }
            }
            valItem.files = valItem.files.filter((_, idx) => idx !== imgIndex);
        },

        // 📂 QUẢN LÝ FILE TÀI LIỆU/BÁO CÁO ĐÍNH KÈM (fileGhiChu)
        triggerDocUpload() {
            this.$refs.docFileInput.click();
        },
        async onDocFileChange(event) {
            if (event.target && event.target.files.length > 0) {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("files", file);

                let loader = this.getLoader(event.target);
                try {
                    const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                    let resultData = response.data;
                    if (resultData.code == 0) {
                        if (!this.model.fileGhiChu) {
                            this.$set(this.model, "fileGhiChu", []);
                        }
                        const newDoc = {
                            fileId: resultData.data.fileId,
                            fileName: resultData.data.fileName,
                            ext: resultData.data.ext,
                            path: resultData.data.path,
                        };
                        this.model.fileGhiChu = [...this.model.fileGhiChu, newDoc];
                    } else {
                        this.notifyError(resultData);
                    }
                } catch (error) {
                    console.error("Error uploading document:", error);
                } finally {
                    if (loader) loader.hide();
                }
            }
        },
        async removeDocFile(index) {
            const file = this.model.fileGhiChu[index];
            if (file && file.fileId) {
                try {
                    await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${file.fileId}`);
                } catch (error) {
                    console.error("Error deleting document file:", error);
                }
            }
            this.model.fileGhiChu = this.model.fileGhiChu.filter((_, idx) => idx !== index);
        },

        // Infographics methods
        triggerInfographicUpload(index) {
            const refName = `infographicFileInput_${index}`;
            if (this.$refs[refName]) {
                this.$refs[refName].click();
            }
        },
        async onInfographicFileChange(event, index) {
            if (event.target && event.target.files.length > 0) {
                const file = event.target.files[0];
                const formData = new FormData();
                formData.append("files", file);

                let loader = this.getLoader(event.target);
                try {
                    const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
                    let resultData = response.data;
                    if (resultData.code == 0) {
                        const updatedInfographics = [...this.model.infographics];
                        updatedInfographics[index] = {
                            fileId: resultData.data.fileId,
                            fileName: resultData.data.fileName,
                            ext: resultData.data.ext,
                            path: resultData.data.path,
                        };
                        this.model.infographics = updatedInfographics;
                    } else {
                        this.notifyError(resultData);
                    }
                } catch (error) {
                    console.error("Error uploading infographic:", error);
                } finally {
                    if (loader) loader.hide();
                }
            }
        },
        async clearInfographic(index) {
            const file = this.model.infographics[index];
            if (file && file.fileId) {
                try {
                    await axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${file.fileId}`);
                } catch (error) {
                    console.error("Error deleting infographic file:", error);
                }
            }
            const updatedInfographics = [...this.model.infographics];
            updatedInfographics[index] = { fileId: "", fileName: "", ext: "", path: "" };
            this.model.infographics = updatedInfographics;
        },

        // UTILS
        getLoader(target) {
            if (this.$loading) {
                return this.$loading.show({
                    container: this.$refs.formContainer,
                    target: target
                });
            }
            return null;
        },
        notifyError(resultData) {
            if (this.$store) {
                this.$store.dispatch("snackBarStore/addNotify", {
                    message: resultData.message || "Thao tác tải lên thất bại",
                    code: resultData.code
                });
            }
        },
        getImageUrl(file) {
            if (!file) return "";
            if (file.fileId) {
                return `${process.env.VUE_APP_API_URL}filesminio/view/${file.fileId}`;
            }
            return file.path || "";
        },
        submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit("save", this.model);
        },
    },
};
</script>

<style scoped>
.modal-premium {
    width: 90% !important;
}

.custom-switch-premium {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: baseline;
    align-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
}

.custom-switch-premium ::v-deep .custom-control-label {
    padding-left: 8px;
    cursor: pointer;
    user-select: none;

}

/* ======================== CHỦ ĐỀ CHUNG & BIẾN SỐ ======================== */
.modal-title-custom {
    font-family: var(--font-heading, "Montserrat"), sans-serif;
    font-size: 1.3rem !important;
    color: var(--color-public-text-head, #1b5e20);
    font-weight: 600 !important;
}

/* ======================== BENTO GRID LAYOUT VIA CSS GRID ======================== */
.bento-container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 24px;
}

.bento-left {
    grid-column: span 12;
}

.bento-right {
    grid-column: span 12;
}

@media (min-width: 992px) {
    .bento-left {
        grid-column: span 8;
    }

    .bento-right {
        grid-column: span 4;
    }
}

/* Bento Card Design */
.bento-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 24px;
    border: 1px solid rgba(187, 202, 186, 0.3);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
}

/* Bento Card Headers */
.card-header-custom {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 24px;
    border-bottom: 1px solid rgba(187, 202, 186, 0.2);
    padding-bottom: 16px;
}

.card-header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.icon-primary {
    color: var(--color-public-primary, #2e7d32);
    font-size: 20px;
}

.card-title-text {
    font-family: var(--font-heading, "Montserrat"), sans-serif;
    font-size: 16px;
    color: var(--color-public-text-head, #1b5e20);
    font-weight: 700;
    margin: 0;
}

.card-subtitle-text {
    font-family: var(--font-heading, "Montserrat"), sans-serif;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-public-text-body, #374151);
    margin: 0;
}

/* ======================== BIỂU MẪU ĐẦU VÀO (FORM) ======================== */
.form-group-custom {
    margin-bottom: 16px;
}

.form-label-custom {
    display: block;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-public-text-body, #374151);
    margin-bottom: 8px;
}

.form-label-xs {
    display: block;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #555;
    margin-bottom: 4px;
}

.form-control-custom {
    width: 100%;
    border: 1px solid var(--outline-variant, #bfcaba);
    border-radius: 8px;
    padding: 12px;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 14px;
    color: var(--color-public-text-body, #374151);
    background-color: #ffffff;
    outline: none;
    transition: all 0.2s ease-in-out;
}

.form-control-custom:focus {
    border-color: var(--color-public-primary, #2e7d32);
    box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.12);
}

.form-control-custom-sm {
    width: 100%;
    border: 1px solid rgba(187, 202, 186, 0.5);
    border-radius: 8px;
    padding: 10px;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 12px;
    color: var(--color-public-text-body, #374151);
    outline: none;
}

.form-control-custom-sm:focus {
    border-color: var(--color-public-primary, #2e7d32);
}

.form-control-custom-xs {
    width: 100%;
    border: 1px solid rgba(187, 202, 186, 0.4);
    border-radius: 6px;
    padding: 6px;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 11px;
    outline: none;
}

.border-danger-custom {
    border-color: var(--color-status-error, #d32f2f) !important;
}

.error-text-custom {
    color: var(--color-status-error, #d32f2f);
    font-size: 11px;
    margin-top: 4px;
    font-family: var(--font-body, "Inter"), sans-serif;
}

.text-italic {
    font-style: italic;
}

/* ======================== QUẢN LÝ THUỘC TÍNH DYNAMIC ======================== */
.btn-add-group-attr {
    background-color: rgba(46, 125, 50, 0.08);
    color: var(--color-public-primary, #2e7d32);
    border: 1px solid rgba(46, 125, 50, 0.3);
    padding: 8px 16px;
    border-radius: 8px;
    font-family: var(--font-heading, "Montserrat"), sans-serif;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    outline: none;
    transition: all 0.2s;
}

.btn-add-group-attr:hover {
    background-color: var(--color-public-primary, #2e7d32);
    color: #ffffff;
}

.group-attr-card {
    background-color: var(--surface-container-low, #f1f5eb);
    border: 1px solid var(--outline-variant, #bfcaba);
    border-radius: 10px;
    overflow: hidden;
}

.group-attr-header {
    background-color: rgba(187, 202, 186, 0.2);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid var(--outline-variant, #bfcaba);
}

.btn-delete-group {
    background-color: transparent;
    border: none;
    color: var(--color-status-error, #d32f2f);
    font-size: 16px;
    cursor: pointer;
    outline: none;
    padding: 4px;
    display: flex;
    align-items: center;
}

.group-attr-body {
    padding: 16px;
}

.btn-add-item-attr {
    background-color: transparent;
    border: none;
    color: var(--color-public-primary, #2e7d32);
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    outline: none;
}

.btn-add-item-attr:hover {
    text-decoration: underline;
}

.val-item-row-card {
    background-color: #ffffff;
    border: 1px solid rgba(187, 202, 186, 0.5);
    padding: 14px;
    border-radius: 8px;
}

.border-dotted {
    border-top: 1px dotted var(--outline-variant, #bfcaba);
}

.btn-delete-row {
    background: transparent;
    border: none;
    color: rgba(0, 0, 0, 0.4);
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
}

.btn-delete-row:hover {
    color: var(--color-status-error, #d32f2f);
}

/* Thumbnail ảnh nhỏ đính kèm trong thuộc tính chi tiết */
.attr-image-preview {
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid var(--outline-variant, #bfcaba);
    display: flex;
    align-items: center;
    justify-content: center;
}

.attr-image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.btn-delete-attr-img {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    color: #ffffff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    cursor: pointer;
    transition: opacity 0.2s;
}

.attr-image-preview:hover .btn-delete-attr-img {
    opacity: 1;
}

.btn-upload-attr-img {
    background-color: transparent;
    border: 1px dashed var(--outline-variant, #bfcaba);
    color: var(--color-public-primary, #2e7d32);
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 11px;
    font-weight: 700;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    outline: none;
    transition: all 0.2s;
}

.btn-upload-attr-img:hover {
    background-color: rgba(46, 125, 50, 0.04);
    border-style: solid;
}

/* ======================== QUẢN LÝ FILE TÀI LIỆU (fileGhiChu) ======================== */
.doc-file-item-card {
    background-color: var(--surface-container-low, #f1f5eb);
    border: 1px solid rgba(187, 202, 186, 0.5);
    padding: 10px 14px;
    border-radius: 8px;
}

.doc-file-name {
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: var(--color-public-text-body, #374151);
    margin: 0;
}

.doc-file-ext {
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
    color: #777;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 1px 4px;
    border-radius: 3px;
}

.btn-delete-doc {
    background: transparent;
    border: none;
    color: rgba(0, 0, 0, 0.4);
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    outline: none;
    padding: 2px;
}

.btn-delete-doc:hover {
    color: var(--color-status-error, #d32f2f);
}

/* ======================== HÌNH ẢNH ĐẠI DIỆN (AVATAR) ======================== */
.avatar-preview-box {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    border-radius: 12px;
    overflow: hidden;
    background-color: var(--surface-container-low, #f1f5eb);
    border: 2px dashed var(--outline-variant, #bfcaba);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    cursor: pointer;
}

.avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.avatar-preview-box:hover .avatar-image {
    transform: scale(1.05);
}

.avatar-placeholder {
    text-align: center;
    padding: 16px;
    color: rgba(55, 65, 81, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.placeholder-icon {
    font-size: 32px;
    margin-bottom: 6px;
    opacity: 0.5;
}

.placeholder-text {
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 12px;
    font-weight: 500;
}

.avatar-hover-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s;
}

.avatar-preview-box:hover .avatar-hover-overlay {
    opacity: 1;
}

.camera-icon-wrapper {
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(8px);
    color: #ffffff;
    padding: 12px;
    border-radius: 9999px;
    transition: transform 0.2s;
}

.avatar-preview-box:hover .camera-icon-wrapper {
    transform: scale(1.1);
}

.avatar-inputs-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.avatar-dimensions-tip {
    text-align: center;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 10px;
    color: rgba(55, 65, 81, 0.6);
    font-style: italic;
    margin-top: 12px;
}

/* ======================== BỘ SƯU TẬP ẢNH (GALLERY) ======================== */
.add-image-btn {
    background: transparent;
    border: none;
    color: var(--color-public-primary, #2e7d32);
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    outline: none;
}

.add-image-btn:hover {
    text-decoration: underline;
}

.gallery-count-text {
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 11px;
    color: rgba(55, 65, 81, 0.6);
    margin: 2px 0 0 0;
}

.gallery-grid-custom {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    max-height: 250px;
    overflow-y: auto;
    padding-right: 4px;
}

.gallery-item-wrapper {
    position: relative;
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid var(--outline-variant, #bfcaba);
    background-color: var(--surface-container-low, #f1f5eb);
}

.gallery-order-badge {
    position: absolute;
    top: 6px;
    left: 6px;
    background-color: rgba(24, 29, 23, 0.7);
    backdrop-filter: blur(4px);
    color: #ffffff;
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 9px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 4px;
    z-index: 2;
    pointer-events: none;
}

.gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease-in-out;
}

.gallery-item-wrapper:hover .gallery-img {
    transform: scale(1.05);
}

.gallery-img-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px;
    text-align: center;
    color: rgba(55, 65, 81, 0.4);
    font-size: 10px;
}

.delete-gallery-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: var(--color-status-error, #d32f2f);
    color: #ffffff;
    border: none;
    width: 22px;
    height: 22px;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s, background-color 0.2s;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    z-index: 3;
}

.gallery-item-wrapper:hover .delete-gallery-btn {
    opacity: 1;
}

.delete-gallery-btn:hover {
    background-color: #b71c1c;
}

.upload-box-custom {
    aspect-ratio: 1;
    border-radius: 8px;
    border: 2px dashed var(--outline-variant, #bfcaba);
    background-color: rgba(241, 245, 235, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
    color: rgba(55, 65, 81, 0.5);
    transition: all 0.2s;
}

.upload-box-custom:hover {
    color: var(--color-public-primary, #2e7d32);
    border-color: var(--color-public-primary, #2e7d32);
    background-color: rgba(46, 125, 50, 0.03);
}

.upload-icon {
    font-size: 20px;
}

.upload-text {
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.gallery-toggle-wrapper {
    margin-top: 14px;
}

.btn-toggle-links {
    width: 100%;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px dashed var(--outline-variant, #bfcaba);
    background-color: var(--surface-container-low, #f1f5eb);
    font-family: var(--font-heading, "Montserrat"), sans-serif;
    font-size: 11px;
    font-weight: 700;
    color: var(--color-public-text-body, #374151);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.15s;
    outline: none;
}

.btn-toggle-links:hover {
    background-color: var(--surface-container-high, #e5eadf);
    color: var(--color-public-primary, #2e7d32);
}

.gallery-links-scroller {
    margin-top: 12px;
    border-top: 1px solid rgba(187, 202, 186, 0.2);
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 180px;
    overflow-y: auto;
    padding-right: 4px;
}

.link-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    border-radius: 8px;
    background-color: rgba(241, 245, 235, 0.4);
    border: 1px solid rgba(187, 202, 186, 0.2);
}

.row-thumbnail {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    overflow: hidden;
    background-color: var(--surface-container-low, #f1f5eb);
    border: 1px solid rgba(187, 202, 186, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.thumb-icon {
    font-size: 16px;
    color: rgba(55, 65, 81, 0.3);
}

.thumb-index {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    font-size: 8px;
    font-weight: 800;
    padding: 0px 3px;
    border-top-left-radius: 3px;
}

.row-inputs {
    flex-grow: 1;
}

/* ======================== THỐNG KÊ (STATS WIDGET) ======================== */
.stats-group-wrapper {
    display: flex;
    flex-direction: column;
}

.views-counter-box {
    background-color: rgba(241, 245, 235, 0.7);
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(187, 202, 186, 0.2);
    margin-top: 16px;
}

.views-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.icon-secondary {
    color: var(--color-public-secondary, #ff8f06);
    font-size: 18px;
}

.views-label {
    font-family: var(--font-body, "Inter"), sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: var(--color-public-text-body, #374151);
}

.views-value {
    font-family: var(--font-heading, "Montserrat"), sans-serif;
    font-size: 18px;
    font-weight: 800;
    color: var(--color-public-secondary, #ff8f06);
}

/* Custom scrollbar & other utilities */
::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(112, 122, 108, 0.2);
    border-radius: 4px;
}

.font-italic {
    font-style: italic;
}

/* ======================== INFOGRAPHICS WIDGETS ======================== */
.infographic-preview-box {
    aspect-ratio: 16/9;
    max-height: 120px;
    margin-top: 8px;
}

.infographic-image {
    object-fit: contain;
    background-color: #f8f9fa;
}

.infographic-placeholder-icon {
    font-size: 20px;
    margin-bottom: 2px;
}

.infographic-placeholder-text {
    font-size: 10px;
}

.infographic-camera-wrapper {
    padding: 6px;
}

.infographic-camera-icon {
    font-size: 14px;
}

/* ======================== CHỨNG NHẬN DỰ PHÒNG CHUYÊN NGHIỆP ======================== */
.certifications-list-scroller {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 4px;
}

.cert-item-card {
    background-color: var(--surface-container-low, #f1f5eb);
    border: 1px solid rgba(187, 202, 186, 0.3);
    border-radius: 12px;
    transition: border-color 0.2s;
}

.cert-item-card:hover {
    border-color: var(--color-public-primary, #2e7d32);
}

.cert-image-preview-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    border: 1px dashed var(--outline-variant, #bfcaba);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #ffffff;
}

.cert-image-preview {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.cert-image-placeholder {
    font-size: 24px;
}

.bg-soft-primary {
    background-color: rgba(46, 125, 50, 0.1);
    color: var(--color-public-primary, #2e7d32);
    font-weight: 600;
}

.btn-xs {
    padding: 0.2rem 0.4rem;
    font-size: 0.75rem;
    border-radius: 4px;
}
</style>